import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import DateConverter from '../Tools/DateConverter'
import GraficaCantidadVenta from './GraficaCantidadVenta';
const server = process.env.REACT_APP_SERVER;

function CantidadVentas() {
    const [fecha, setFecha] = useState('');
    const [fechas, setFechas] = useState([]);
    const [anios, setAnios] = useState(0);
    const [sucursales, setSucursales] = useState([]);
    function obtenerDatos() {
        if (fecha != '' && anios > 0) {
            var fechasGeneradas = []
            for (var i = 0; i < anios; i++) {
                fechasGeneradas.push(DateConverter.getFechaMenosAnios(fecha, -i))
            }
            setFechas(fechasGeneradas);
            console.log(fechasGeneradas);
        } else {
            MsgUtils.msgError("Colocar la fecha de referencia por favor")
        }
    }
    function getSucursales() {
        if (sucursales.length == 0) {
            fetch(`${server}/sqlComun/getSucursales`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'regional': JSON.parse(localStorage.getItem('__react_session__')).regional
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        MsgUtils.msgError(data.error);
                    } else {
                        setSucursales(data.ok)
                    }
                })
                .catch(error => MsgUtils.msgError(error));
        }
    }
    useEffect(() => {
        getSucursales();
    }, [])
    return (
        <>
            <div className='container-fluid bg-dark bg-gradient py-1'>
                <div className='row row-cols g-1' style={{ marginRight: '40px' }}>
                    <div className='col' style={{ maxWidth: '210px' }}>
                        <div className="input-group input-group-sm">
                            <span className="input-group-text bg-transparent text-light">Fecha</span>
                            <input type="date" className="form-control form-control-sm" value={fecha} onChange={(e) => setFecha(e.target.value)} />
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '180px' }}>
                        <div className="input-group input-group-sm">
                            <span className="input-group-text bg-transparent text-light">Historico Anual</span>
                            <input type="number" className="form-control form-control-sm" value={anios} onChange={(e) => setAnios(e.target.value)} />
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '120px', minWidth: '120px' }}>
                        <button className='btn btn-sm btn-success w-100' onClick={() => obtenerDatos()}><i className="fa-solid fa-chart-simple"></i> Graficar</button>
                    </div>
                </div>
            </div>
            {fechas.length != 0 && <div className='container-fluid'>
                {fechas.map((item, index) => {
                    return (
                        <div className='mb-2 bg-dark' key={index}>
                            <div className='text-center fw-bold text-light'>Fecha: {item}</div>
                            <GraficaCantidadVenta fecha={item} sucursales={sucursales} />
                        </div>
                    )
                })}
            </div>}
        </>
    )
}

export default CantidadVentas